import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Crest } from "./common";

const FormPill = ({ r }) => (
  <span className={`w-4 h-4 rounded-full text-[9px] font-black flex items-center justify-center ${
    r === "W" ? "bg-green text-cream" : r === "D" ? "bg-gold text-ink" : "bg-live text-cream"}`}>{r}</span>
);

// Branded standings table rendered from our own /api/table data.
export function LeagueTable({ rows, compact = false }) {
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto rounded-sm border border-pslborder bg-white" data-testid="league-table">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-green text-cream text-[11px] uppercase tracking-wide">
            <th className="py-2.5 px-2 text-center w-8">#</th>
            <th className="py-2.5 px-2 text-left">Club</th>
            <th className="py-2.5 px-1 text-center w-8">P</th>
            {!compact && <><th className="py-2.5 px-1 text-center w-8">W</th><th className="py-2.5 px-1 text-center w-8">D</th><th className="py-2.5 px-1 text-center w-8">L</th><th className="py-2.5 px-1 text-center w-9">GF</th><th className="py-2.5 px-1 text-center w-9">GA</th></>}
            <th className="py-2.5 px-1 text-center w-10">GD</th>
            <th className="py-2.5 px-2 text-center w-10">Pts</th>
            {!compact && <th className="py-2.5 px-3 text-center hidden sm:table-cell">Form</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.club_slug} onClick={() => navigate(`/clubs/${r.club_slug}`)} className="border-t border-pslborder hover:bg-cream transition-colors cursor-pointer" data-testid={`table-row-${r.club_slug}`}>
              <td className={`py-2 px-2 text-center font-head font-bold ${r.position <= 4 ? "text-gold" : r.position >= 16 ? "text-live" : "text-ink/50"}`}>{r.position}</td>
              <td className="py-2 px-2">
                <Link to={`/clubs/${r.club_slug}`} className="flex items-center gap-2 font-semibold hover:text-green">
                  <Crest slug={r.club_slug} name={r.club_name} size={22} />
                  <span className="truncate">{r.club_name}</span>
                </Link>
              </td>
              <td className="py-2 px-1 text-center tabular text-ink/70">{r.played}</td>
              {!compact && <><td className="py-2 px-1 text-center tabular text-ink/70">{r.won}</td><td className="py-2 px-1 text-center tabular text-ink/70">{r.drawn}</td><td className="py-2 px-1 text-center tabular text-ink/70">{r.lost}</td><td className="py-2 px-1 text-center tabular text-ink/70">{r.gf}</td><td className="py-2 px-1 text-center tabular text-ink/70">{r.ga}</td></>}
              <td className="py-2 px-1 text-center tabular text-ink/70">{r.gd > 0 ? `+${r.gd}` : r.gd}</td>
              <td className="py-2 px-2 text-center font-head font-black text-green tabular">{r.points}</td>
              {!compact && <td className="py-2 px-3 hidden sm:table-cell"><div className="flex gap-1 justify-center">{(r.form || "").split("").slice(-5).map((f, i) => <FormPill key={i} r={f} />)}</div></td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
